export const ISO693_TO_1 = {
  aar: 'aa',
  abk: 'ab',
  ave: 'ae',
  afr: 'af',
  aka: 'ak',
  amh: 'am',
  arg: 'an',
  ara: 'ar',
  asm: 'as',
  ava: 'av',
  aym: 'ay',
  aze: 'az',
  bak: 'ba',
  bel: 'be',
  bul: 'bg',
  bih: 'bh',
  bis: 'bi',
  bam: 'bm',
  ben: 'bn',
  bod: 'bo',
  tib: 'bo',
  bre: 'br',
  bos: 'bs',
  cat: 'ca',
  che: 'ce',
  cha: 'ch',
  cos: 'co',
  cre: 'cr',
  ces: 'cs',
  cze: 'cs',
  chu: 'cu',
  chv: 'cv',
  cym: 'cy',
  wel: 'cy',
  dan: 'da',
  deu: 'de',
  ger: 'de',
  div: 'dv',
  dzo: 'dz',
  ewe: 'ee',
  ell: 'el',
  gre: 'el',
  eng: 'en',
  epo: 'eo',
  spa: 'es',
  est: 'et',
  baq: 'eu',
  eus: 'eu',
  fas: 'fa',
  per: 'fa',
  ful: 'ff',
  fin: 'fi',
  fij: 'fj',
  fao: 'fo',
  fra: 'fr',
  fre: 'fr',
  fry: 'fy',
  gle: 'ga',
  gla: 'gd',
  glg: 'gl',
  grn: 'gn',
  guj: 'gu',
  glv: 'gv',
  hau: 'ha',
  heb: 'he',
  hin: 'hi',
  hmo: 'ho',
  hrv: 'hr',
  hat: 'ht',
  hun: 'hu',
  arm: 'hy',
  hye: 'hy',
  her: 'hz',
  ina: 'ia',
  ind: 'id',
  ile: 'ie',
  ibo: 'ig',
  iii: 'ii',
  ipk: 'ik',
  ido: 'io',
  ice: 'is',
  isl: 'is',
  ita: 'it',
  iku: 'iu',
  jpn: 'ja',
  jav: 'jv',
  geo: 'ka',
  kat: 'ka',
  kon: 'kg',
  kik: 'ki',
  kua: 'kj',
  kaz: 'kk',
  kal: 'kl',
  khm: 'km',
  kan: 'kn',
  kor: 'ko',
  kau: 'kr',
  kas: 'ks',
  kur: 'ku',
  kom: 'kv',
  cor: 'kw',
  kir: 'ky',
  lat: 'la',
  ltz: 'lb',
  lug: 'lg',
  lim: 'li',
  lin: 'ln',
  lao: 'lo',
  lit: 'lt',
  lub: 'lu',
  lav: 'lv',
  mlg: 'mg',
  mah: 'mh',
  mao: 'mi',
  mri: 'mi',
  mac: 'mk',
  mkd: 'mk',
  mal: 'ml',
  mon: 'mn',
  mar: 'mr',
  may: 'ms',
  msa: 'ms',
  mlt: 'mt',
  bur: 'my',
  mya: 'my',
  nau: 'na',
  nob: 'nb',
  nde: 'nd',
  nep: 'ne',
  ndo: 'ng',
  dut: 'nl',
  nld: 'nl',
  nno: 'nn',
  nor: 'no',
  nbl: 'nr',
  nav: 'nv',
  nya: 'ny',
  oci: 'oc',
  oji: 'oj',
  orm: 'om',
  ori: 'or',
  oss: 'os',
  pan: 'pa',
  pli: 'pi',
  pol: 'pl',
  pus: 'ps',
  por: 'pt',
  que: 'qu',
  roh: 'rm',
  run: 'rn',
  ron: 'ro',
  rum: 'ro',
  rus: 'ru',
  kin: 'rw',
  san: 'sa',
  srd: 'sc',
  snd: 'sd',
  sme: 'se',
  sag: 'sg',
  sin: 'si',
  slk: 'sk',
  slo: 'sk',
  slv: 'sl',
  smo: 'sm',
  sna: 'sn',
  som: 'so',
  alb: 'sq',
  sqi: 'sq',
  srp: 'sr',
  ssw: 'ss',
  sot: 'st',
  sun: 'su',
  swe: 'sv',
  swa: 'sw',
  tam: 'ta',
  tel: 'te',
  tgk: 'tg',
  tha: 'th',
  tir: 'ti',
  tuk: 'tk',
  tgl: 'tl',
  tsn: 'tn',
  ton: 'to',
  tur: 'tr',
  tso: 'ts',
  tat: 'tt',
  twi: 'tw',
  tah: 'ty',
  uig: 'ug',
  ukr: 'uk',
  urd: 'ur',
  uzb: 'uz',
  ven: 've',
  vie: 'vi',
  vol: 'vo',
  wln: 'wa',
  wol: 'wo',
  xho: 'xh',
  yid: 'yi',
  yor: 'yo',
  zha: 'za',
  chi: 'zh',
  zho: 'zh',
  zul: 'zu',
};
